<template>
  <div class="box-sign-up">
    <h2 class="login-title">Sign up for free</h2>
    <b-form
      style="text-align: left"
      aria-autocomplete="off"
      @submit.prevent="submitSignup"
    >
      <b-input-group class>
        <span class="formIcons">
          <UserIcon />
        </span>
        <b-form-input
          ref="firstNameInput"
          name="firstName"
          v-model="$v.form.firstName.$model"
          :state="validateInput('firstName')"
          class="LoginInput"
          size="lg"
          placeholder="First name"
          aria-describedby="firstName-feedback"
        ></b-form-input>
        <b-form-invalid-feedback id="firstName-feedback" v-bind:tooltip="false"
          >This is a required field.</b-form-invalid-feedback
        >
      </b-input-group>

      <!-- Last Name Input -->
      <b-input-group class>
        <span class="formIcons">
          <UserIcon />
        </span>
        <b-form-input
          name="lastName"
          v-model="$v.form.lastName.$model"
          :state="validateInput('lastName')"
          class="LoginInput"
          size="lg"
          placeholder="Last name"
          aria-describedby="lastName-feedback"
        ></b-form-input>
        <b-form-invalid-feedback id="lastName-feedback" v-bind:tooltip="false"
          >This is a required field.</b-form-invalid-feedback
        >
      </b-input-group>
      <!-- E-mail Input -->
      <b-input-group class>
        <span class="formIcons email">
          <EmailIcon />
        </span>
        <b-form-input
          type="email"
          name="email"
          class="LoginInput"
          size="lg"
          v-model="$v.form.email.$model"
          :state="validateInput('email')"
          @blur="checkEmail()"
          placeholder="E-mail"
          aria-autocomplete="off"
          aria-describedby="email-feedback"
        ></b-form-input>
        <div v-show="this.emailIsRegistered" class="invalid-feedback-custom">
          This email is already associated with a Dropsmith's account. Please,
          <a :href="dsAppUrl">click here to log in</a>.
        </div>
        <b-form-invalid-feedback id="email-feedback" v-bind:tooltip="false"
          >Must be a valid email address.</b-form-invalid-feedback
        >
      </b-input-group>

      <!-- Password Input -->
      <b-input-group class>
        <span class="formIcons password">
          <PasswordIcon />
        </span>
        <b-form-input
          class="LoginInput"
          size="lg"
          type="password"
          name="password"
          v-model="$v.form.password.$model"
          :state="validateInput('password')"
          placeholder="Create password"
          aria-autocomplete="off"
          aria-describedby="password-feedback"
        ></b-form-input>
        <b-form-invalid-feedback id="password-feedback" v-bind:tooltip="false">
          Your password must be at least 6 characters.
        </b-form-invalid-feedback>
      </b-input-group>
      <!-- Newsletter accept -->
      <b-form-group class="signup-checkbox">
        <b-form-checkbox
          id="acceptTerms"
          v-model="$v.form.acceptTerms.$model"
          name="acceptTerms"
          :state="validateInput('acceptTerms')"
          aria-describedby="terms-conditions-feedback"
        >
          I agree to Dropsmart's
          <a target="_blank" :href="termsAndConditionsUrl"
            >terms and conditions</a
          >
        </b-form-checkbox>

        <b-form-checkbox
          id="acceptNewsletter"
          name="acceptNewsletter"
          v-model="form.subscribeToMailGroup"
        >
          I want to stay informed by Dropsmart's newsletter
        </b-form-checkbox>
      </b-form-group>

      <div class="textGDPR">
        <p>
          We respect the GDPR rules. Your privacy is important to us. We don't send spam, and you can unsubscribe at any time.
        </p>
      </div>

      <button class="button-login" type="submit" id="submitLogin">
        <b-spinner v-show="showLoad"></b-spinner>
        <span class id="button-text" v-if="!showLoad">Create free account</span>
      </button>
    </b-form>
  </div>
</template>

<script>
import PasswordIcon from "./icons/PasswordIcon.vue";
import EmailIcon from "./icons/EmailIcon.vue";
import UserIcon from "./icons/UserIcon.vue";
import { BACKEND_URL, FRONTEND_URL } from "../config.js";

import { validationMixin } from "vuelidate";

import { required, minLength, email, sameAs } from "vuelidate/lib/validators";

export default {
  components: {
    PasswordIcon,
    EmailIcon,
    UserIcon,
  },
  mixins: validationMixin,
  validations: {
    form: {
      firstName: {
        required,
        minLength: minLength(2),
      },
      lastName: {
        required,
        minLength: minLength(2),
      },
      email: {
        required,
        email,
      },
      password: {
        required,
        minLength: minLength(6),
      },
      acceptTerms: {
        sameAs: sameAs(() => true),
      },
    },
  },
  computed: {
    validForm: function () {
      return !this.$v.form.$anyError;
    },
  },
  data() {
    return {
      emailIsRegistered: false,
      showLoad: false,
      termsAndConditionsUrl: BACKEND_URL.TermsAndConditions,
      dsAppUrl: FRONTEND_URL.AppLoginPage,
      form: {
        firstName: null,
        lastName: null,
        email: null,
        password: null,
        acceptTerms: false,
        subscribeToMailGroup: false,
      },
    };
  },
  methods: {
    submitSignup() {
      this.$v.form.$touch();
      console.log(this.$v.form.$error);
      if (!this.validForm) {
        return;
      }
      this.formDisabled = true;
      this.showLoad = true;

      let url = BACKEND_URL.FreeSignup;
      console.log("SUBMITING THE SIGNUP FORM TO " + url);
      fetch(BACKEND_URL.FreeSignup, {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(this.form),
        headers: { "Content-type": "application/json" },
        cache: "no-cache",
      })
        .then((response) => {
          if (response.ok) {
            this.$router.push({
              name: "ThankYou",
              params: { isUpgrade: false },
            });
          } else {
            if (response.status == 409) {
              console.log("Email already exists");
            }
            throw Error(response.status + ": " + response.statusText);
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.showLoad = false;
        });
    },
    checkEmail() {
      if (!this.form.email) {
        return;
      }
      let url = BACKEND_URL.CheckEmail + "?email=" + this.form.email;
      console.log("checking " + url);
      fetch(url, {
        method: "GET",
        mode: "cors",
      })
        .then((response) => {
          if (response.ok || response.status == 204) {
            this.emailIsRegistered = response.status != 204;
          } else {
            throw Error(response.status + " " + response.statusText);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    validateInput(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
  },
  mounted() {
    this.emailIsRegistered = false;
    this.$v.form.$reset();
  },
};
</script>

<style lang="scss">
main {
  overflow-x: hidden;
  height: 100%;
}
.box-sign-up {
  padding: 0 15px;
}
.login-title {
  color: #000000;
  font-size: 36px;
  font-weight: 700;
  margin-bottom: 0;
  padding: 0px 0 30px;
  text-align: center;
  text-transform: uppercase;
  width: 100%;
}
.checkout-checkbox {
  margin: 15px 0 10px;
}
.textinfo {
  color: #434343;
  font-size: 18px;
  text-align: center;
  max-width: 350px;
  margin: 15px auto;
  span {
    font-weight: 700;
  }
}
.button-login {
  background: #ffffff;
  border: 1px solid #79b867;
  border-radius: 50px;
  color: #79b867;
  font-size: 20px;
  font-weight: 400;
  line-height: 53px;
  margin-bottom: 8px;
  padding: 0 15px;
  text-transform: uppercase;
  width: 100%;
  .spinner-border {
    vertical-align: middle;
  }
  &:hover {
    background: #000000;
    border-color: #000000;
    color: #ffffff;
  }
  &:focus {
    outline: none;
  }
}
.btn-more {
  background: #79b867;
  border: 1px solid #79b867;
  border-radius: 50px;
  color: #ffffff;
  display: block;
  font-size: 20px;
  font-weight: 700;
  line-height: 53px;
  margin-bottom: 8px;
  padding: 0 15px;
  text-align: center;
  text-transform: uppercase;
  width: 100%;
  &:hover {
    text-decoration: none;
    background: #000000;
    border-color: #000000;
    color: #ffffff;
  }
}
.text-privacy {
  font-size: 14px;
  text-align: center;
  max-width: 310px;
  margin: 25px auto;
}
.textGDPR {
  font-size: 16px;
  margin: 0;
  text-align: center;
}
.box-sign-up {
  fieldset {
      margin: 30px 0px 5px;
    }
}
.signup-checkbox {  
    .custom-control {
      padding-left: 50px;
    }    
    .custom-control-label { 
      font-size: 16px;   
      line-height: 20px;
      margin-bottom: 25px;
    &::after {
      top: 50%;
      margin-top: -11px;
      margin-left: -12px;
      width: 21px;
      height: 21px;
    }
    &::before {
      background-color: #e5e5e5;
      border-color: #e5e5e5 !important;
      top: 50%;
      margin-top: -11px;
      margin-left: -12px;
      border-radius: 0;
      width: 21px;
      height: 21px;
    }            
  }  
  .custom-control-input:checked ~ .custom-control-label::before,
  .was-validated .custom-control-input:valid:checked ~ .custom-control-label::before, 
  .custom-control-input.is-valid:checked ~ .custom-control-label::before {
    border-color: #68a432 !important;
    background-color: #68a432 !important;
  }
  .was-validated .custom-control-input:valid:focus ~ .custom-control-label::before, 
  .custom-control-input.is-valid:focus ~ .custom-control-label::before {
    box-shadow: none;
  }
  .was-validated .custom-control-input:valid ~ .custom-control-label, 
  .custom-control-input.is-valid ~ .custom-control-label {
    color: #000000;
  }
  .was-validated .custom-control-input:invalid:focus:not(:checked) ~ .custom-control-label::before, 
  .custom-control-input.is-invalid:focus:not(:checked) ~ .custom-control-label::before {

  }
  .was-validated .custom-control-input:valid:checked ~ .custom-control-label::before, 
  .custom-control-input.is-valid:checked ~ .custom-control-label::before {
    border-color: #e5e5e5;
  }
  .custom-radio .custom-control-input:checked ~ .custom-control-label::after {
      background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23000'/%3e%3c/svg%3e");
  }
  .was-validated .custom-control-input:invalid ~ .custom-control-label, 
  .custom-control-input.is-invalid ~ .custom-control-label {
    
  }
  .custom-control-input:focus ~ .custom-control-label::before {
    box-shadow: none !important;
  }
  .was-validated .custom-control-input:invalid ~ .custom-control-label::before, 
  .custom-control-input.is-invalid ~ .custom-control-label::before {
    border-color: #e5e5e5 !important;
    outline: none;
    box-shadow: none !important;
  }
}
</style>